import { Map } from 'immutable';
import { combineReducers } from 'redux-immutable'
import getCurrentWeeksArray from '../../functions/getCurrentWeeksArray';
import pushCreateReducer from './pushCreateReducer';
import pushListReducer from './pushListReducer';


const WEEKS = getCurrentWeeksArray()
const INIT_STATE = Map({})

const combinedReducer = combineReducers({
    create:  pushCreateReducer(WEEKS),
    list:  pushListReducer(WEEKS)
})

const pushServerDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default pushServerDataReducer;